import { ICheckboxGroupValue } from "component-library";

import { mapCheckboxValueToList } from "shared/helpers/mappers";
import { IConverter } from "shared/services/api/types";

import { IMakeSuggestionsFilterParams } from "models/api";

import {
  FilterType,
  IFilterModel,
  whichCVToFilterMapping,
} from "hoc/withMakeSuggestionsFilter/withMakeSuggestionsFilter.config";

export class FilterModelToMakeSuggestionsFilterParamsConverter
  implements IConverter<IFilterModel, IMakeSuggestionsFilterParams>
{
  convert(filterModel: IFilterModel): IMakeSuggestionsFilterParams {
    const agents = mapCheckboxValueToList(filterModel[FilterType.Agents], {});

    return {
      skip:
        (filterModel[FilterType.PageNumber]
          ? filterModel[FilterType.PageNumber] - 1
          : 0) * (filterModel[FilterType.PageSize] ?? 0),
      textFilter: filterModel[FilterType.TextFilter] || undefined,
      whichCV: whichCVToFilterMapping[filterModel[FilterType.WhichCV]],
      agents: agents.length ? agents : undefined,
      gender: this.convertCheckboxValue(filterModel[FilterType.Gender]),
      playingAgeFrom: filterModel[FilterType.PlayingAge].minValue,
      playingAgeTo: filterModel[FilterType.PlayingAge].maxValue,
      take: filterModel[FilterType.PageSize] || undefined,
      appearances: this.convertCheckboxValue(
        filterModel[FilterType.Appearance]
      ),
      locationId: filterModel[FilterType.Locations].map(
        (location) => location.value
      ),
      heritageAndEthnicity: [
        ...mapCheckboxValueToList(filterModel[FilterType.EthnicBackground]),
        ...mapCheckboxValueToList(filterModel[FilterType.HeritageAndEthnicity]),
      ],
      heritageAndEthnicityFilterMode:
        filterModel[FilterType.HeritageAndEthnicityFilterMode],
      heritageAndEthnicityInfo:
        filterModel[FilterType.HeritageAndEthnicityInfo],
    };
  }

  convertCheckboxValue(
    checkboxValue: ICheckboxGroupValue
  ): number[] | undefined {
    const selectedValues = mapCheckboxValueToList(checkboxValue);

    return selectedValues.length ? selectedValues : undefined;
  }
}
